import { FormControlLabel, Switch, Tooltip, Typography } from '@mui/material';
import { IFormField } from 'components/@material-extend/formik-form';
import { get } from 'lodash';
import * as React from 'react';

export interface SwitchProps {
  item: IFormField;
  values: any;
  switchCallback: any;
}
export default function MFormSwitch({ item, values, switchCallback }: SwitchProps) {
  const {
    name,
    label,
    handleChange,
    tooltip = '',
    showValueLabel,
    valueLabelTrue,
    valueLabelFalse,
    disabled
  } = item;

  const checked: boolean = get(values, name);

  return (
    <div key={`${name}`}>
      <FormControlLabel
        labelPlacement="start"
        control={
          tooltip ? (
            <Tooltip title={tooltip}>
              <Switch
                onChange={(event) => {
                  const { checked } = event.target;
                  switchCallback(item, checked);
                  if (handleChange) handleChange(event);
                }}
                disabled={disabled}
                checked={checked}
              />
            </Tooltip>
          ) : (
            <Switch
              onChange={(event) => {
                const { checked } = event.target;
                switchCallback(item, checked);
                if (handleChange) handleChange(event);
              }}
              disabled={disabled}
              checked={checked}
            />
          )
        }
        label={
          showValueLabel ? (
            <Typography
              variant="body2"
              component="span"
              sx={checked ? { color: 'text.primary' } : { color: 'text.secondary' }}
            >
              {checked ? valueLabelTrue : valueLabelFalse}
            </Typography>
          ) : (
            <Typography variant="body2" sx={{ color: 'text.secondary' }}>
              {label}
            </Typography>
          )
        }
      />
    </div>
  );
}
